import React from 'react'
import { ThemeProvider } from 'former-kit'
import theme from 'former-kit-skin-pagarme'
import { HashRouter } from 'react-router-dom'
import { Provider as StateProvider } from 'react-redux'

import store from './configureStore'
import Root from './pages/Root'
import GlobalOtpModal from './components/OtpModal/GlobalOtpModal'
import './styles.global.css'

const App = () => (
  <ThemeProvider theme={theme}>
    <StateProvider store={store}>
      <HashRouter>
        <Root />
        <GlobalOtpModal />
      </HashRouter>
    </StateProvider>
  </ThemeProvider>
)

export default App
